import React, { FC } from 'react'

import { MenuMobile } from '@components/shared/menu/menu-mobile'
import { ApiScope, Menu } from '@services/api/menus'

import { SearchTool } from '@components/search-tool'
import { useWindowDimensions } from '@hooks/use-window-dimensions'
import { MenuDesktop } from '../menu-desktop'

const contentPart2: Menu[] = [
  {
    description: 'O&M Usinas Solares',
    id: 9996,
    itemOrder: 2,
    newTab: false,
    parentId: null,
    scope: ApiScope.MAIN,
    status: 'published',
    rel: 'nofollow',
    target: '_blank',
    url: 'https://pvoperation.com'
  }
]

const contentPart1: Menu[] = [
  {
    description: 'Calculadora',
    id: 9994,
    itemOrder: 5,
    newTab: false,
    parentId: null,
    scope: ApiScope.MAIN,
    status: 'published',
    url: '/calculadora-solar'
  }
]

export const MenuContent: FC<{ content: Menu[] }> = ({ content }) => {
  const { width } = useWindowDimensions()
  const isMobile = width < 1024

  const newContent = [
    ...content.filter(
      contentItem =>
        contentItem.description === 'Notícias' ||
        contentItem.description === 'Guia Solar'
    ),
    ...contentPart1,
    ...content.filter(
      contentItem => contentItem.description === 'Cursos de Energia Solar'
    ),
    ...contentPart2
  ]

  return (
    <div className="w-full flex flex-col items-center overflow-hidden">
      <div className="w-full max-w-7xl flex flex-col py-2 px-4 md:px-8 md:pb-14 xl:px-0">
        <div className="w-full h-[1px] bg-[#00000026] mb-5 md:mb-6 lg:mb-8" />

        <SearchTool />

        <nav className="flex flex-col lg:flex-row gap-2 lg:gap-6 mt-5 md:mt-6 lg:mt-8 xl:mt-12">
          {isMobile ? (
            newContent.map(({ id, ...props }) => (
              <MenuMobile key={`menu-item-${id}`} id={id} {...props} />
            ))
          ) : (
            <MenuDesktop content={newContent} />
          )}
        </nav>
      </div>
    </div>
  )
}
